import { FILE_FORMATS } from 'JS/config/consts';

const getFileTypeFromFormat = format => {
  const fileType = FILE_FORMATS.find(ff => ff.key === format);

  return fileType?.title || 'Unknown';
};

export default getFileTypeFromFormat;
